import { Star } from "lucide-react";

export default function StarRating({ value = 0, size = 16, className = "" }) {
  return (
    <div className={`flex items-center gap-0.5 ${className}`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} style={{ width: size, height: size }}
          className={i <= Math.round(value) ? "fill-amber text-amber" : "fill-slate-200 text-slate-200"} />
      ))}
    </div>
  );
}
